// extracted by mini-css-extract-plugin
export default {"date-container":"DateIndicator_date-container__lmHDC"};